import { COMMON_TEXT_PATH_REGEXPS } from '../constants'
import { PageConfiguration } from '../types/page-configuration'

export const PAGES = [
  {
    pageId: 'about',
    screen: 'about',
    regex: /^\/about(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'admin-alert-new',
    screen: 'admin_alerts',
    regex: /^\/admin_alert\/new(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'advertising',
    screen: 'advertising',
    regex: /^\/advertising(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'app',
    screen: 'app',
    regex: /^\/app(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'app-feedbacks',
    screen: 'product_feedback_form',
    regex: /^\/app_feedbacks(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'banned',
    screen: 'banned',
    regex: /^\/main\/banned(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'brands-by-letter',
    screen: 'brands_by_letter',
    regex: /^\/brands\/by_letter\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'brand',
    screen: 'catalog',
    regex: /^\/brand(?:\/([^/]+?))(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'brands',
    screen: 'brands',
    regex: /^\/brands(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'catalog',
    screen: 'catalog',
    regex: /^\/vetements(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'catalog',
    screen: 'catalog',
    regex: /^\/catalog(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'catalog-brand',
    screen: 'catalog',
    regex: /^\/catalog\/([^/]+?)\/brand\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'catalog-by-id',
    screen: 'catalog',
    regex: /^\/catalog\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'catalog-by-id',
    screen: 'catalog',
    regex: /^\/vetements\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'complaints-new',
    screen: 'contact_support_form',
    regex: /^\/complaints\/new(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'complaints-report',
    screen: 'complaint_form',
    regex: /^\/complaints\/report(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'complaint',
    screen: 'view_issue_details',
    regex: /^\/complaints\/([^/]+?)(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'checkout',
    screen: 'checkout',
    regex: /^\/checkout(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'closet-promotion-stats',
    screen: 'cp_stats',
    regex: /^\/closet_promotions\/stats(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'dac7',
    screen: 'dac7',
    regex: /^\/dac7(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'delete-account',
    screen: 'delete_account',
    regex: /^\/delete_account(?:\/)?$/,
    requireAuthorization: true,
  },

  {
    pageId: 'complaint-faq-entry',
    screen: 'faq_entry',
    regex: /^\/complaints\/([^/]+?)\/faq_entry(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'dev-load',
    screen: 'unknown',
    regex: /^\/dev\/load\/([^/]+?)(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dev-debug',
    screen: 'unknown',
    regex: /^\/dev\/debug(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dev-error-boundary-app',
    screen: 'unknown',
    regex: /^\/dev\/error-boundary-app(?:\/)?$/,
    requireAuthorization: true,
    requiredRole: 'god',
  },
  {
    pageId: 'dev-error-boundary-component',
    screen: 'unknown',
    regex: /^\/dev\/error-boundary-component(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dev-error-boundary-layout',
    screen: 'unknown',
    regex: /^\/dev\/error-boundary-layout(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dev-error-client',
    screen: 'unknown',
    regex: /^\/dev\/error-client(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dev-error-log',
    screen: 'unknown',
    regex: /^\/dev\/error-log(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dev-error-server-render',
    screen: 'unknown',
    regex: /^\/dev\/error-server-render(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dev-experiment',
    screen: 'unknown',
    regex: /^\/dev\/experiment(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dev-root-params',
    screen: 'unknown',
    regex: /^\/dev\/root-params(?:\/)?$/,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    pageId: 'dsa-appeal-education',
    screen: 'dsa_appeal_education',
    regex: /^\/dsa\/appeal_education(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'dsa-notice-appeal',
    screen: 'dsa_notice_appeal',
    regex: /^\/dsa\/notice_appeal(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'dsa-ntd-appeal',
    screen: 'dsa_ntd_appeal',
    regex: /^\/dsa\/ntd_appeal(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'feedback',
    screen: 'feedback',
    regex: /^\/feedback\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'help-center',
    screen: 'help_center_home',
    regex: /^\/help(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'trendsales-payout-form',
    screen: 'trendsales_payout_form',
    regex: /^\/help\/trendsales_payout(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'desk-post-ticket-survey',
    screen: 'desk_post_ticket_survey_form',
    regex: /^\/hcf\/(.+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'live-chat-form',
    screen: 'live_chat_form',
    regex: /^\/help\/for_transaction\/([^/]+?)\/live_chat(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'landing-page-builder',
    screen: 'landing-page-builder',
    regex: /^\/landing-page-builder(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'help-center-for-transaction',
    screen: 'help_center_transaction',
    regex: /^\/help\/for_transaction\/([^/]+?)(?:\/(.+?))?(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'help-center-new-support-ticket',
    screen: 'contact_form',
    regex: /^\/help\/support_tickets\/new(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'help-center-intellectual-property-infringement',
    screen: 'intellectual_property_infringement',
    regex: /^\/help\/intellectual_property_infringement(?:\/(.+?))?(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'help-center-notice-and-action-form',
    screen: 'notice_and_action_form',
    regex: /^\/help\/notice_and_action_form(?:\/(.+?))?(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'help-center-search',
    screen: 'help_center_search',
    regex: /^\/help\/s(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'help-center-recent-transactions',
    screen: 'help_center_recent_transactions',
    regex: /^\/help\/recent_transactions(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'help-center-faq',
    screen: 'help_center_faq',
    regex: /^\/help\/(.+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'homepage-block',
    screen: 'more_homepage_items',
    regex: /^\/homepage\/block(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'how-it-works',
    screen: 'how_it_works',
    regex: /^\/how_it_works(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'inbox',
    screen: 'message_list',
    regex: /^\/inbox(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'inbox-message',
    screen: 'message_list',
    regex: /^\/inbox\/([^/]+?)(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'inbox-message-details',
    screen: 'message_list',
    regex: /^\/inbox\/([^/]+?)\/details(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'info-board-post',
    screen: 'info_post',
    regex: /^\/infoboard\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'no-changes-to-taxes',
    screen: 'no_changes_to_taxes',
    regex: /^\/no-changes-to-taxes(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'notification-landings',
    screen: 'notification_landings',
    regex: /^\/notification_landings(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'privacy-policy',
    screen: 'privacy_policy',
    regex: /^\/privacy-policy(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'privacy',
    screen: 'privacy_center',
    regex: /^\/privacy(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'private-beta-terms-of-use',
    screen: 'private_beta_terms_of_use',
    regex: /^\/private-beta-terms-of-use(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro',
    screen: 'business_homepage',
    regex: /^\/pro(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-integrations',
    screen: 'pro_integrations',
    regex: /^\/pro\/integrations(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-integrations-application',
    screen: 'pro_integrations_application',
    regex: /^\/pro\/integrations\/application(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-integrations-terms-and-conditions',
    screen: 'pro_integrations_terms_and_conditions',
    regex: /^\/pro\/integrations\/terms-and-conditions(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'digital-product-passport',
    screen: 'pro_integrations',
    regex: /^\/digital-product-passport\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-kyb',
    screen: 'kyb_form',
    regex: /^\/pro\/kyb(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'pro-register',
    screen: 'registration_business_details',
    regex: /^\/pro\/register(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'pro-register-business-details',
    screen: 'registration_business_details',
    regex: /^\/pro\/register\/business-details(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-register-business-profile',
    screen: 'registration_business_details',
    regex: /^\/pro\/register\/business-profile(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-register-business-representative',
    screen: 'registration_business_details',
    regex: /^\/pro\/register\/business-representative(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-wallet-conversion',
    screen: 'wallet_conversion',
    regex: /^\/pro\/wallet_conversion(?:\/)?$/,
    requireAuthorization: true,
    requiredRole: 'none',
  },
  {
    pageId: 'pro-add-vat',
    screen: 'add_vat',
    regex: /^\/pro\/add_vat(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-terms-and-conditions',
    screen: 'pro_terms_and_conditions',
    regex: /^\/pro-terms-and-conditions(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'old-pro-terms-and-conditions',
    screen: 'old_pro_terms_and_conditions',
    regex: /^\/old-pro-terms-and-conditions(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'pro-terms-of-use',
    screen: 'pro_terms_of_use',
    regex: /^\/pro-terms-of-use(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'referral-invite',
    screen: 'referral_invite',
    regex: /^\/invite\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'referrals-registrations',
    screen: 'referral_code_share',
    regex: /^\/referrals\/registrations(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'referrals',
    screen: 'referral_code_share',
    regex: /^\/referrals(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'login-select-type',
    screen: 'auth_select_type_login',
    regex: /^\/member\/login\/select_type(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'login-email',
    screen: 'auth_email_login',
    regex: /^\/member\/login\/email(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'login-reset-password',
    screen: 'auth_reset_password',
    regex: /^\/member\/login\/reset_password(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'login-2fa',
    screen: 'auth_two_factor_login',
    regex: /^\/member\/login\/2fa(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'register-select-type',
    screen: 'auth_select_type_register',
    regex: /^\/member\/register\/select_type(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'register-email',
    screen: 'auth_email_register',
    regex: /^\/member\/register\/email(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'register-facebook',
    screen: 'auth_facebook_register',
    regex: /^\/member\/register\/facebook(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'register-google',
    screen: 'auth_google_register',
    regex: /^\/member\/register\/google(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'register-apple',
    screen: 'auth_apple_register',
    regex: /^\/member\/register\/apple(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'register-password-verification',
    screen: 'auth_confirm_password',
    regex: /^\/member\/register\/password_verification(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'issue_details',
    screen: 'complaint_proof',
    regex: /^\/issue_details\/([^/]+?)(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'item-verification',
    screen: 'item_verification',
    regex: /^\/item_verification(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'items-new-push-up',
    screen: 'multiple_push_up',
    regex: /^\/items\/push_up\/new(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'items-new',
    regex: /^\/items\/new(?:\/)?$/,
    requireAuthorization: true,
    screen: 'upload_item',
  },
  {
    pageId: 'item-edit',
    requireAuthorization: true,
    screen: 'upload_item',
    regex: /^\/items\/([^/]+?)\/edit(?:\/)?$/,
  },
  {
    pageId: 'item',
    screen: 'item',
    requireAuthorization: false,
    regex: /^\/items\/([^/]+?)(?:\/)?$/,
  },
  {
    pageId: 'info-board',
    regex: /^\/infoboard(?:\/)?$/,
    requireAuthorization: false,
    screen: 'info_board',
  },
  {
    requireAuthorization: true,
    pageId: 'member-accept-business-invitation',
    screen: 'accept_business_invitation',
    regex: /^\/member\/accept_business_invitation(?:\/)?$/,
  },
  {
    pageId: 'member-balance-activation',
    screen: 'payments_account',
    regex: /^\/member\/balance_activation(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'member-full-name-confirmation',
    screen: 'full_name_confirmation',
    requireAuthorization: true,
    regex: /^\/member\/full_name_confirmation(?:\/)?$/,
  },
  {
    pageId: 'member-general-change-forgot-password',
    screen: 'change_forgot_password',
    requireAuthorization: false,
    regex: /^\/member\/general\/change_forgot_password(?:\/)?$/,
  },
  {
    pageId: 'member-general-change-password',
    requireAuthorization: true,
    screen: 'change_password',
    regex: /^\/member\/general\/change_password(?:\/)?$/,
  },
  {
    pageId: 'member-general-delete-account',
    screen: 'delete_account',
    requireAuthorization: true,
    regex: /^\/member\/general\/delete_account(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'member-general-delete-account-success',
    screen: 'delete_account_success',
    requireAuthorization: false,
    regex: /^\/member\/general\/delete_account_success(?:\/)?$/,
  },
  {
    pageId: 'session-refresh',
    screen: 'session_refresh',
    requireAuthorization: false,
    regex: /^\/session-refresh(?:\/)?$/,
  },
  {
    pageId: 'member-general-reset-password',
    screen: 'password_change',
    requireAuthorization: false,
    regex: /^\/member\/general\/reset_password(?:\/)?$/,
    redirectAuthorised: true,
  },
  {
    pageId: 'member-general-search',
    screen: 'users',
    requireAuthorization: false,
    regex: /^\/member\/general\/search(?:\/)?$/,
  },
  {
    pageId: 'member-items-favourite-list',
    screen: 'favorite_item_list',
    regex: /^\/member\/items\/favourite_list(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'member-items-reservation',
    screen: 'item_reservation',
    regex: /^\/member\/items\/reservation(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'member-notifications',
    screen: 'notification_list',
    regex: /^\/member\/notifications(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'member-personal-data-export-download',
    requireAuthorization: true,
    screen: 'download_data_export',
    regex: /^\/member\/personal_data_export\/download(?:\/)?$/,
  },
  {
    pageId: 'member-personalization-brands',
    screen: 'browse_all_brands',
    regex: /^\/member\/personalization\/brands(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'member-personalization-brands-followed',
    screen: 'browse_all_brands',
    regex: /^\/member\/personalization\/brands\/followed(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'member-personalization-sizes',
    screen: 'feed_size_categories',
    regex: /^\/member\/personalization\/sizes(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'member-personalization-history',
    screen: 'personalisation_history',
    regex: /^\/member\/personalization\/history(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'member-settings-confirm-email',
    screen: 'email_confirm_change',
    regex: /^\/member\/settings\/email\/confirm(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'member-settings-new-email',
    screen: 'change_email',
    regex: /^\/member\/settings\/email\/new(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'member-signup-email-start',
    screen: 'email_register',
    regex: /^\/member\/signup\/email_start(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'member-signup-select-type',
    screen: 'select_login_type',
    regex: /^\/member\/signup\/select_type(?:\/)?$/,
    requireAuthorization: false,
    redirectAuthorised: true,
  },
  {
    pageId: 'member-general-followers',
    requireAuthorization: false,
    screen: 'users',
    regex: /^\/member\/general\/followers\/([^/]+?)(?:\/)?$/,
  },
  {
    pageId: 'member-general-following',
    screen: 'users',
    regex: /^\/member\/general\/following\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'member-personalization-sizes-by-category',
    screen: 'feed_size_categories',
    regex: /^\/member\/personalization\/sizes\/([^/]+?)(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'member',
    requireAuthorization: false,
    screen: 'user_profile',
    regex: /^\/member\/([^/]+?)(?:\/)?$/,
  },
  {
    pageId: 'member-bundles',
    screen: 'bundling',
    requireAuthorization: false,
    regex: /^\/member\/([^/]+?)\/bundles\/new(?:\/)?$/,
  },
  {
    pageId: 'member-new-feedback',
    screen: 'user_leave_feedback',
    regex: /^\/member\/([^/]+?)\/feedback\/new(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'member-edit-feedback',
    screen: 'feedback_edit',
    regex: /^\/member\/([^/]+?)\/feedback\/([^/]+?)\/edit(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'my-orders',
    screen: 'orders_list',
    regex: /^\/my_orders(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'my-orders-by-type',
    screen: 'orders_list',
    regex: /^\/my_orders(?:\/([^/]+?))?(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'order-details',
    screen: 'escrow_order_details',
    regex: /^\/order_details\/([^/]+?)(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'root',
    screen: 'news_feed',
    regex: /^\/(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'influencer-landing-page',
    requireAuthorization: false,
    screen: 'influencer_landing_page',
    regex: /^\/the-wardrobe-edit\/([^/]+?)(?:\/)?$/,
  },
  {
    pageId: 'safety-policy',
    screen: 'safety_policy',
    regex: /^\/safety(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'safety-policy-pro',
    screen: 'safety_policy',
    regex: /^\/safety_pro(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'settings-account',
    screen: 'account_settings',
    requireAuthorization: true,
    regex: /^\/settings\/account(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-account-staff',
    screen: 'account_staff',
    regex: /^\/settings\/account_staff(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-bundle-discount',
    screen: 'bundle_discount_settings',
    regex: /^\/settings\/bundle_discount(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-donations',
    screen: 'donations_overview',
    regex: /^\/settings\/donations(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-epr',
    screen: 'epr_settings',
    regex: /^\/settings\/epr(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-payments',
    screen: 'payment_settings',
    regex: /^\/settings\/payments(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-policies',
    screen: 'policies_settings',
    requireAuthorization: false,
    regex: /^\/settings\/policies(?:\/)?$/,
  },
  {
    pageId: 'settings-privacy',
    screen: 'privacy_settings',
    regex: /^\/settings\/privacy(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-profile',
    screen: 'profile_settings',
    regex: /^\/settings\/profile(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-profile-username-change',
    screen: 'username_change',
    regex: /^\/settings\/profile\/username_change(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-security',
    screen: 'security_settings',
    regex: /^\/settings\/security(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-security-payments-identity',
    screen: 'identity_confirmation',
    regex: /^\/settings\/payments_identity(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-security-payments-identity-mobile',
    screen: 'identity_confirmation',
    regex: /^\/settings\/payments_identity\/mobile(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-security-payments-identity-simplified',
    screen: 'identity_confirmation_simplified',
    regex: /^\/settings\/payments_identity_simplified(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-security-phone-verification',
    screen: 'verification_prompt_phone',
    regex: /^\/settings\/security\/phone_verification(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-security-sessions',
    screen: 'security_sessions',
    regex: /^\/settings\/security\/sessions(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-shipping',
    screen: 'shipping_settings',
    regex: /^\/settings\/shipping(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-subscriptions',
    screen: 'subscription_settings',
    regex: /^\/settings\/subscriptions(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'settings-tax-rules',
    screen: 'taxpayers_tax_rules',
    regex: /^\/settings\/tax_rules(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-taxpayer',
    screen: 'taxpayers_info_submission_form',
    regex: /^\/settings\/taxpayer(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'settings-taxpayer-center',
    requireAuthorization: true,
    screen: 'taxpayers_reporting_center',
    regex: /^\/settings\/taxpayer_center(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-taxpayer-education',
    requireAuthorization: true,
    screen: 'taxpayers_education',
    regex: /^\/settings\/taxpayer_education(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-taxpayer-report',
    screen: 'taxpayers_report',
    regex: /^\/settings\/taxpayer_report(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'settings-taxpayer-summary',
    screen: 'taxpayers_report_history',
    requireAuthorization: true,
    regex: /^\/settings\/taxpayer_summary(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'request-data-export',
    screen: 'request_data_export',
    requireAuthorization: true,
    regex: /^\/settings\/privacy\/request_data_export(?:\/)?$/,
  },
  {
    pageId: 'revision',
    screen: 'unknown',
    regex: /^\/revision(?:\/)?$/,
    requireVpn: true,
    requiredRole: 'god',
    requireAuthorization: true,
  },
  {
    requireAuthorization: true,
    pageId: 'request-data-export',
    screen: 'request_data_export',
    regex: /^\/personal_data_export\/confirm(?:\/)?$/,
  },
  {
    pageId: 'taxpayers-special-verification-form',
    screen: 'taxpayers_special_verification_form',
    regex: /^\/taxpayers\/special_verification(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'terms-and-conditions',
    screen: 'terms_view',
    regex: /^\/terms_and_conditions(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'transaction-new-mark-as-sold',
    screen: 'item_mark_as_sold',
    requireAuthorization: true,
    regex: /^\/transactions\/([^/]+?)\/mark_as_sold\/new(?:\/)?$/,
  },
  {
    requireAuthorization: false,
    pageId: 'member-items-close',
    screen: 'item_mark_as_sold',
    regex: /^\/member\/items\/close(?:\/)?$/,
  },
  {
    pageId: 'users-education-mobile-conversations',
    screen: 'first_sale_education_screen',
    regex: /^\/users\/education\/mobile\/conversations(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'user-migration',
    requireAuthorization: false,
    screen: 'user_migration',
    regex: /^\/users\/migration(?:\/)?$/,
  },
  {
    pageId: 'users-verification',
    screen: 'user_verification',
    regex: /^\/users\/verification(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'users-verification-2fa',
    screen: 'bank_2fa_verification',
    requireAuthorization: true,
    regex: /^\/users\/verification\/user_2fa(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'users-verification-new-phone-number',
    requireAuthorization: true,
    screen: 'create_phone_number',
    regex: /^\/users\/verification\/phone\/new(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'users-verification-edit-phone-number',
    screen: 'phone_change',
    requireAuthorization: true,
    regex: /^\/users\/verification\/phone\/edit(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'users-verification-new-email',
    screen: 'email_verification',
    requireAuthorization: true,
    regex: /^\/users\/verification\/email\/new(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'users-verification-email-code',
    screen: 'mand_email_verification',
    requireAuthorization: true,
    regex: /^\/users\/verification\/email_code(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'users-verification-email-code-success',
    screen: 'mand_email_verification_success',
    requireAuthorization: true,
    regex: /^\/users\/verification\/email_code\/success(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'wallet-balance',
    screen: 'payments_account',
    regex: /^\/wallet\/balance(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'wallet-balance-donate',
    screen: 'payments_account',
    requireAuthorization: true,
    regex: /^\/wallet\/balance\/donate(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'wallet-bank-account',
    screen: 'bank_account',
    regex: /^\/wallet\/bank_account(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'wallet-history',
    screen: 'wallet_history',
    regex: /^\/wallet\/history(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'wallet-history-by-year-month',
    screen: 'wallet_history',
    requireAuthorization: true,
    regex: /^\/wallet\/history\/([^/]+?)\/([^/]+?)(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'wallet-history-overview',
    screen: 'wallet_history_overview',
    requireAuthorization: false,
    regex: /^\/wallet\/history\/overview(?:\/)?$/,
  },
  {
    pageId: 'wallet-invoices',
    screen: 'wallet_invoices',
    requireAuthorization: true,
    regex: /^\/wallet\/invoices(?:\/)?$/,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'wallet-income-reports',
    screen: 'income_reports',
    regex: /^\/wallet\/income_reports(?:\/)?$/,
    requireAuthorization: true,
    restrictedRole: 'contributor',
  },
  {
    pageId: 'wallet-new-payout',
    screen: 'new_payout',
    regex: /^\/wallet\/payouts\/new(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'wallet-payout',
    screen: 'payout_status',
    regex: /^\/wallet\/payouts\/([^/]+?)(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'wallet-setup',
    screen: 'payments_account',
    regex: /^\/wallet\/setup(?:\/)?$/,
    restrictedRole: 'contributor',
    requireAuthorization: true,
  },
  {
    pageId: 'common-text',
    screen: 'cookie_policy',
    regex: /^\/cookie-policy(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'common-text',
    screen: 'catalog_rules',
    regex: /^\/catalog-rules(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'common-text',
    screen: 'catalog_rules',
    regex: /^\/old-catalog-rules(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'accessibility',
    screen: 'accessibility',
    regex: /^\/accessibility(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'dac7',
    screen: 'dac7',
    regex: /^\/uk-reporting(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'user-migration',
    screen: 'user_migration',
    regex: /^\/user_migration(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'buy-electronics-landing-page',
    screen: 'buy_electronics_landing_page',
    regex: /^\/buy_electronics(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'sell-electronics-landing-page',
    screen: 'sell_electronics_landing_page',
    regex: /^\/sell_electronics(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'new-again-landing-page',
    screen: 'new_again',
    regex: /^\/new-again(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'house-of-vinted-landing-page',
    screen: 'house_of_vinted_landing_page',
    regex: /^\/house-of-vinted(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'listing-restriction',
    screen: 'listing_restriction',
    regex: /^\/listing-restriction(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'selling-restriction',
    screen: 'selling_restriction',
    regex: /^\/selling-restriction(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'member-personal-data-export-download',
    requireAuthorization: true,
    screen: 'download_data_export',
    regex: /^\/personal_data_export\/download(?:\/)?$/,
  },
  {
    pageId: 'personal-data-export-download-direct',
    screen: 'download_data_export',
    regex: /^\/personal_data_export\/download\/direct(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'van-privacy-policy',
    screen: 'van_privacy_policy',
    regex: /^\/van-privacy-policy\/([^/]+?)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'available-discounts-landing-page',
    screen: 'campaign_landing_page',
    regex: /^\/available_discounts(?:\/)?$/,
    requireAuthorization: true,
  },
  {
    pageId: 'more-items-page',
    screen: 'more_items',
    regex: /^\/items\/([^/]+?)\/more_items(?:\/)?$/,
    requireAuthorization: false,
  },
  {
    pageId: 'shopping-assistant',
    screen: 'shopping_assistant',
    regex: /^\/shopping_assistant(?:\/)?$/,
    requireAuthorization: true,
    requireVpn: true,
  },

  ...COMMON_TEXT_PATH_REGEXPS.map(regex => ({
    pageId: 'common-text' as const,
    screen: 'common_text',
    regex: new RegExp(regex),
    requireAuthorization: false,
  })),
] satisfies ReadonlyArray<PageConfiguration & { regex: RegExp }>
